import React from 'react'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import Button from '@material-ui/core/Button'
import { strings } from '../../../localization/strings'
import { getErrorString } from '../../../utils/exceptions'

/**
 * A modal dialog can only be closed by selecting one of the actions.
 */

class CustomDialog extends React.Component {
    state = {
        open: false,
        message: {},
        callback: null,
    }

    componentDidMount() {
        window.showDialog = (error, successCallback, cancelCallback) => {
            let title = error ? error.title : strings.dialogDefaultTitle
            title = title ? title : strings.dialogDefaultTitle
            let message = error
                ? getErrorString(error)
                : strings.dialogDefaultMessage
            message = message ? message : strings.dialogDefaultMessage
            let okLabel = error.okLabel || strings.dialogOkLabel

            if (
                !!error &&
                !!error.response &&
                !!error.response.data &&
                error.response.data.exceptionName ===
                    'ShopNotActivatedException'
            ) {
                successCallback = false
            }
            this.setState({
                open: true,
                title: title,
                message: message,
                callback: successCallback,
                cancelCallback: cancelCallback,
                fullWidth: error ? error.fullWidth : undefined,
                okLabel: okLabel,
            })
        }
    }

    handleClose = (callback) => {
        this.setState({ open: false })
        callback && callback()
    }

    render() {
        const { open, title, message, cancelCallback, callback, okLabel } =
            this.state
        return (
            <Dialog
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                open={open}
                //onClose={this.handleClose}
                fullWidth={this.state.fullWidth}
            >
                <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
                <DialogContent>
                    {message.type ? (
                        message
                    ) : (
                        <DialogContentText
                            variant={'subtitle1'}
                            id="alert-dialog-description"
                            style={{
                                whiteSpace: 'pre-line',
                            }}
                        >
                            {message}
                        </DialogContentText>
                    )}
                </DialogContent>
                <DialogActions>
                    {cancelCallback ? (
                        <Button
                            onClick={() => this.handleClose(cancelCallback)}
                            color="secondary"
                        >
                            {strings.dialogCancelLabel}
                        </Button>
                    ) : null}

                    {callback !== false ? (
                        <Button
                            onClick={() => this.handleClose(callback)}
                            color="primary"
                        >
                            {okLabel}
                        </Button>
                    ) : null}
                </DialogActions>
            </Dialog>
        )
    }
}

export default CustomDialog
